export class CookieHandler {
  static getCookieByName = (name: string): string | null => {
    try {
      const nameEQ = name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
      }
    } catch (err: any) {
      console.error(`Error in CookieHandler.getCookieByName(): ${err.message}`);
    }
    return null;
  };
}
